import AbstractScene from './AbstractScene.js';
import Popup from '../prefabs/Popup.js';
import ButtonArrow from '../prefabs/buttons/ButtonArrow.js';

export default class End extends AbstractScene {
    constructor() {
        super({
            key: "End"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }


    // update(){

    // }

    create() {

        this.background = this.add.image(0, 0, 'endBackground').setOrigin(0, 0);

        let ctnt = "Remontez sur le bateau pour en parler avec le capitaine Ernesto..."
        this.popup = new Popup(this, ctnt, undefined, () => { this.firstBtn.setAlpha(1) })
        this.popup.setPosition(this.width / 2, 850);
        this.popup.launchAnim()

        this.firstBtn = new ButtonArrow(this, this.width - 140, this.height - 60, 204, 56, "Suivant", "24px", false).setAlpha(0);
        this.firstBtn.setClickFunction(() => {
            this.scene.start('EndVideo');
        })
    }
}